/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { IdTitleReference } from './idTitleReference';

export type MandateAssignmentEvaluation = IdTitleReference | null;
